import './App.css';
import Home from './pages/Home';
import NotFoundPage from "./pages/NotFound"
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
         <Route path='*' element={<NotFoundPage />} />
      </Routes>



      </BrowserRouter>


  );
}

export default App;
